import './Tabs.scss';

import React, { ReactElement, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

type OptionProps = {
  text: string;
  value: string;
  uri?: string;
  isActive?: boolean;
};

export type TabsProps = {
  children: ReactElement[];
  tabOptions: OptionProps[];
  testId?: string;
};

const Tabs = ({ children, tabOptions, testId = 'tab' }: TabsProps): ReactElement => {
  const history = useHistory();
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const handleTabClick = (index: number, uri?: string) => {
    console.log(uri);
    if (uri) {
      history.push(uri);
    } else {
      setActiveTabIndex(index);
    }
  };

  useEffect(() => {
    tabOptions.map((option, index) => {
      if (option.isActive) {
        setActiveTabIndex(index);
      }
      return option;
    });
  }, [tabOptions]);

  return (
    <div className="fixed-tabs">
      <div className="lp-nav" data-trestid={`${testId}-nav`}>
        <ul className="nav nav-pills" role="tablist">
          {tabOptions.map((option, index) => (
            <li
              className="nav-item"
              data-testid={`${testId}-nav-item-${option.value}`}
              key={option.value}
              onClick={() => handleTabClick(index, option.uri)}
            >
              <div
                className={`nav-link show ${activeTabIndex === index ? 'active' : ''}`}
                role="tab"
                aria-selected={activeTabIndex === index}
              >
                {option.text}
              </div>
            </li>
          ))}
        </ul>
      </div>
      {children[activeTabIndex]}
    </div>
  );
};

export default Tabs;
